import { Theme } from '@mui/material';

export const iconButtonStyles = (theme: Theme) => ({
  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: '.25rem',
        transitionProperty:
          'color, background-color, border-color, text-decoration-color, fill, stroke',
        transitionTimingFunction: 'cubic-bezier(.4,0,.2,1)',
        transitionDuration: '.15s',
        color: `${theme.palette.text.secondary}`,
        '&:hover': {
          backgroundColor: `${theme.palette.action.hover}`,
          color: `${theme.palette.text.primary}`,
        },
      },
    },
  },
});
